
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surah/read/[slug]/history",
      function () {
        return require("private-next-pages/surah/read/[slug]/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surah/read/[slug]/history"])
      });
    }
  